import { s3ConnectorPrefix, S3TestConnectionPayload, urlCombine } from 'ihub/common';
import { handleResponse, microServiceAPI, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class S3ConnectorHttpService {
	private testConnectionPath = 'TestConnection';

	async testConnection(
		s3TestConnectionPayload: S3TestConnectionPayload,
		options?: HttpResponseOptions
	) {
		const url = urlCombine(microServiceAPI, s3ConnectorPrefix, this.testConnectionPath);
		const response = await standardPost(url, s3TestConnectionPayload);
		await handleResponse(response, 'Test Connection', s3ConnectorPrefix, options);
	}
}
